// Loaded on the standalone CSV SQL tool (csv-sql-tool/index.html), which
// is not under Turbo.
import { Application } from "stimulus"
import { configureHoneybadger } from "../src/honeybadger"
import AnalyticsController from "../src/controllers/analytics"
import TrackerController from "../src/controllers/tracker"

document.addEventListener("DOMContentLoaded", () => {
  const stimulus = Application.start()
  stimulus.register("tracker", TrackerController)
  stimulus.register("analytics", AnalyticsController)

  configureHoneybadger()
})
